var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGradientLoadingIcon = function SvgGradientLoadingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#GradientLoadingIcon_svg__a)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 2400,
    height: 2400,
    x: -1200,
    y: -1200,
    transform: "rotate(90 0 10)scale(.01)"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255,255,255,0) 0deg,#cc0c1c 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.462a8.461 8.461 0 1 0 0-16.923 8.461 8.461 0 0 0 0 16.923M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10",
    clipRule: "evenodd",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":0.80000001192092896,\"g\":0.047058824449777603,\"b\":0.10980392247438431,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":0.80000001192092896,\"g\":0.047058824449777603,\"b\":0.10980392247438431,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":6.1232342099862801e-15,\"m01\":-20.0,\"m02\":20.0,\"m10\":20.0,\"m11\":6.1232342099862801e-15,\"m12\":0.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "GradientLoadingIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18.462a8.461 8.461 0 1 0 0-16.923 8.461 8.461 0 0 0 0 16.923M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10",
    clipRule: "evenodd"
  })))));
};
export default SvgGradientLoadingIcon;